import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TeamMember } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type CreateTeamMemberDto = {
  color?: string;
  email: string;
  name: string;
  role: string;
  startDate: string;
};

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useCreateTeamMember = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: createMember, isPending } = useAppMutation([QueryKey.CREATE_TEAM_MEMBER], {
    mutationFn: (body: CreateTeamMemberDto) =>
      ApiService.post<TeamMember, CreateTeamMemberDto>(
        { endpoint: BackendRoute.TEAM_MEMBERS },
        { body },
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_TEAM_MEMBERS] }),
  });

  return { createMember, isPending };
};
